// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"13b1b085","399":"98570de3","573":"bed8e86e","588":"f3aca13c","683":"8f9ad0e4","784":"f60bb5dd","787":"bed44058"}[chunkId] + ".chunk.js";
};